class PredictiveSearch extends SearchForm {
  constructor() {
    super();
    this.cachedResults = {};
    this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
    this.predictiveSearchResultsLeft = this.querySelector('#list-result-collections');
    this.predictiveSearchResultsRight = this.querySelector('#list-result-products');
    this.allPredictiveSearchInstances =
      document.querySelectorAll('predictive-search');
    this.isOpen = false;
    this.abortController = new AbortController();
    this.searchTerm = '';
    this.fetchInProgress = {}; // Initialize as an object to track fetch states
    this.cachedResults = {}; // Assuming this is also initialized
    this.allPredictiveSearchInstances = []; // Initialize as needed
    this.setupEventListeners();


  }

  setupEventListeners() {
    this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));

    this.input.addEventListener('focus', this.onFocus.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.addEventListener('keyup', this.onKeyup.bind(this));
    this.addEventListener('keydown', this.onKeydown.bind(this));
    this.addEventListener('change', this.onChange.bind(this));

    document.querySelectorAll('.search--back').forEach(t => {
      t.addEventListener('click', (e) => {
        this.closest('details').removeAttribute('open')
      });
    })
    
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    super.onChange();
    const newSearchTerm = this.getQuery();
    if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {
      // Remove the results when they are no longer relevant for the new search term
      // so they don't show up when the dropdown opens again
      this.querySelector("#predictive-search-results-groups-wrapper")?.remove();
    }

    // Update the term asap, don't wait for the predictive search query to finish loading
    this.updateSearchForTerm(this.searchTerm, newSearchTerm);

    this.searchTerm = newSearchTerm;

    if (!this.searchTerm.length) {
      this.close(true);
      return;
    }

    this.getSearchResults(this.searchTerm);
  }

  onFormSubmit(event) {
    if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) event.preventDefault();
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.searchTerm = '';
      this.abortController.abort();
      this.abortController = new AbortController();
      this.closeResults(true);
    }
  }

  onFocus() {
    const currentSearchTerm = this.getQuery();

    if (!currentSearchTerm.length) return;

    if (this.searchTerm !== currentSearchTerm) {
      // Search term was changed from other search input, treat it as a user change
      this.onChange();
    } else if (this.getAttribute('results') === 'true') {
      this.open();
    } else {
      this.getSearchResults(this.searchTerm);
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  onKeyup(event) {
    if (!this.getQuery().length) this.close(true);
    event.preventDefault();

    switch (event.code) {
      case 'ArrowUp':
        this.switchOption('up')
        break;
      case 'ArrowDown':
        this.switchOption('down');
        break;
      case 'Enter':
        this.selectOption();
        break;
    }
  }

  onKeydown(event) {
    // Prevent the cursor from moving in the input when using the up and down arrow keys
    if (
      event.code === 'ArrowUp' ||
      event.code === 'ArrowDown'
    ) {
      event.preventDefault();
    }
  }

  updateSearchForTerm(previousTerm, newTerm) {
    const searchForTextElement = this.querySelector(
      "[data-predictive-search-search-for-text]"
    );
    const currentButtonText = searchForTextElement?.innerText;
    if (currentButtonText) {
      if (currentButtonText.match(new RegExp(previousTerm, "g")).length > 1) {
        // The new term matches part of the button text and not just the search term, do not replace to avoid mistakes
        return;
      }
      const newButtonText = currentButtonText.replace(previousTerm, newTerm);
      searchForTextElement.innerText = newButtonText;
    }
  }

  switchOption(direction) {
    if (!this.getAttribute('open')) return;

    const moveUp = direction === 'up';
    const selectedElement = this.querySelector('[aria-selected="true"]');

    // Filter out hidden elements (duplicated page and article resources) thanks
    // to this https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/offsetParent
    const allVisibleElements = Array.from(
      this.querySelectorAll("li, button.predictive-search__item")
    ).filter((element) => element.offsetParent !== null);
    let activeElementIndex = 0;

    if (moveUp && !selectedElement) return;

    let selectedElementIndex = -1;
    let i = 0;

    while (selectedElementIndex === -1 && i <= allVisibleElements.length) {
      if (allVisibleElements[i] === selectedElement) {
        selectedElementIndex = i;
      }
      i++;
    }

    this.statusElement.textContent = "";

    if (!moveUp && selectedElement) {
      activeElementIndex =
        selectedElementIndex === allVisibleElements.length - 1
          ? 0
          : selectedElementIndex + 1;
    } else if (moveUp) {
      activeElementIndex =
        selectedElementIndex === 0
          ? allVisibleElements.length - 1
          : selectedElementIndex - 1;
    }

    if (activeElementIndex === selectedElementIndex) return;

    const activeElement = allVisibleElements[activeElementIndex];

    activeElement.setAttribute('aria-selected', true);
    if (selectedElement) selectedElement.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', activeElement.id);
  }

  selectOption() {
    const selectedOption = this.querySelector(
      '[aria-selected="true"] a, button[aria-selected="true"]'
    );

    if (selectedOption) selectedOption.click();
  }

  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(" ", "-").toLowerCase();

    // Check if a search is already in progress for this term
    if (this.fetchInProgress[queryKey]) {
        return; // Exit if a fetch is already in progress
    }

    this.setLiveRegionLoadingState();

    // Check cache first
    if (this.cachedResults[queryKey]) {
        this.renderSearchResults(this.cachedResults[queryKey]);
        return;
    }

    // Set the flag to indicate a fetch is in progress
    this.fetchInProgress[queryKey] = true;

    let url_fetch_old = `${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&section_id=predictive-search`;
    let url_fetch_new = `${routes.search_url}?q=${encodeURIComponent(searchTerm)}&predict=true&section_id=custom-search&sort_by=relevan&options%5Bprefix%5D=last`;

    // Create an array of fetch promises
    const fetchOld = fetch(url_fetch_old, { signal: this.abortController.signal })
        .then((response) => {
            if (!response.ok) {
                var error = new Error(response.status);
                this.close();
                throw error;
            }
            return response.text();
        })
        .then((text) => {
            return {
                type: 'collections',
                markup: new DOMParser().parseFromString(text, 'text/html').querySelector('#list-result-collections').innerHTML,
            };
        });

    const fetchNew = fetch(url_fetch_new, { signal: this.abortController.signal })
        .then((response) => {
            if (!response.ok) {
                var error = new Error(response.status);
                this.close();
                throw error;
            }
            return response.text();
        })
      	.then((text) => {
        	const button_search = new DOMParser().parseFromString(text, 'text/html').querySelector('#predictive-search-option-search-keywords').innerHTML;
			document.querySelector('.predictive-search__search-for-button').innerHTML = button_search;
			document.querySelector('.row-search-result').classList.remove('flex-reverse')
			document.querySelector('.row-search-result').classList.add('flex-reverse');
        
			return {
				type: 'products',
				markup: new DOMParser().parseFromString(text, 'text/html').querySelector('#list-result-products').innerHTML,
			};
        });

    	// Use Promise.all() to run both fetches concurrently
    Promise.all([fetchOld, fetchNew])
      .then(([resultOld, resultNew]) => {
        // Handle collections results
        if (resultOld) {
          this.predictiveSearchResultsLeft.innerHTML = resultOld.markup;
          this.predictiveSearchResultsLeft.classList.remove('hideOnMobile');
          this.predictiveSearchResultsLeft.classList.add('hideOnMobile');
          //update mobile to rows 
         // console.log("DELETE",  document.querySelectorAll('.searchResultProduct.type-collections').length)
        document.querySelectorAll('.searchResultProduct.type-collections').forEach(t => t.remove());
				setTimeout(() => {
					const number_rows = 2;
					document.querySelectorAll('.searchResultProduct.showOnMobile').forEach((item, index) => {
						if (index === number_rows) {
							//console.log("SHOW INJECT")
							const searchResultDiv = document.createElement('div');
							searchResultDiv.classList.add('searchResultProduct', 'showOnMobile', 'type-collections');
				
							// Create the main row div
							const rowDiv = document.createElement('div');
							rowDiv.classList.add('row');
				
							// Create the column div
							const colDiv = document.createElement('div');
							colDiv.classList.add('col-md-12');
				
							const colDivInner = document.createElement('div');
							colDivInner.innerHTML = resultOld.markup
				
							// Append the image to the col div
							colDiv.appendChild(colDivInner);
				
							// Append the col div to the row div
							rowDiv.appendChild(colDiv);
				
							// Append the row div to the searchResultProduct div
							searchResultDiv.appendChild(rowDiv);
				
							// Insert the searchResultProduct div after the matched product element
							item.insertAdjacentElement('afterend', searchResultDiv);

							// Exit the loop after inserting the ad
							return;  // Stops further iteration
						}
					});
				}, 0);
				
            }

            // Handle products results
            if (resultNew) {
                gtag("event", "search", {
                  search_term: searchTerm
                });
                              
                this.predictiveSearchResultsRight.innerHTML = resultNew.markup;
				this.afterRender();

				const ads_settings_ctx = document.querySelector('#ads_image_settings').textContent;
				const ads_settings = JSON.parse(ads_settings_ctx);

				if (ads_settings && ads_settings?.row_number && ads_settings.row_number != "") {
					const number_row = parseInt(ads_settings.row_number) - 1;
					document.querySelectorAll('.searchResultProduct.showOnDesktop').forEach((item, index) => {
						if (index === number_row) {
							// Create the outer searchResultProduct div
							const searchResultDiv = document.createElement('div');
							searchResultDiv.classList.add('searchResultProduct', 'type-ads');
				
							// Create the main row div
							const rowDiv = document.createElement('div');
							rowDiv.classList.add('row');
				
							// Create the column div
							const colDiv = document.createElement('div');
							colDiv.classList.add('col-md-12');
				
							// Create the image element
							const img = document.createElement('img');
							img.src = ads_settings.ads_image;
							img.alt = 'Ad Banner';
				
							// Append the image to the col div
							colDiv.appendChild(img);
				
							// Append the col div to the row div
							rowDiv.appendChild(colDiv);
				
							// Append the row div to the searchResultProduct div
							searchResultDiv.appendChild(rowDiv);
				
							// Insert the searchResultProduct div after the matched product element
							item.insertAdjacentElement('afterend', searchResultDiv);

							// Exit the loop after inserting the ad
							return;  // Stops further iteration
						}
					});
				}

				if (this.getQuery().length && document.querySelectorAll('.searchResultProduct.showOnDesktop').length > 4) {
					document.querySelector('.predictive-search__search-for-button').style.display = 'flex';
				}
				else {
					document.querySelector('.predictive-search__search-for-button').style.display = 'none';
				}

            }

            // Cache the results for future requests
            this.allPredictiveSearchInstances.forEach((predictiveSearchInstance) => {
                predictiveSearchInstance.cachedResults[queryKey] = {
                    collections: resultOld.markup,
                    products: resultNew.markup,
                };
            });

        })
        .finally(() => {
            // Reset the flag to indicate the fetch is complete
            this.fetchInProgress[queryKey] = false;
        })
        .then(() => this.afterRender())
        .catch((error) => {
            if (error?.code === 20) {
                // Code 20 means the call was aborted
                return;
            }
            this.close();
            throw error;
        });
}


  setLiveRegionLoadingState() {
    this.statusElement = this.statusElement || this.querySelector('.predictive-search-status');
    this.loadingText = this.loadingText || this.getAttribute('data-loading-text');

    this.setLiveRegionText(this.loadingText);
    this.setAttribute('loading', true);
  }

  setLiveRegionText(statusText) {
    this.statusElement.setAttribute('aria-hidden', 'false');
    this.statusElement.textContent = statusText;

    setTimeout(() => {
      this.statusElement.setAttribute('aria-hidden', 'true');
    }, 1000);
  }

  renderSearchResults(resultsMarkup) {
    setTimeout(() => {
      this.predictiveSearchResults.innerHTML = resultsMarkup;
    }, 500);
    this.setAttribute('results', true);

    this.setLiveRegionResults();
    this.open();

    setTimeout(() => {
      //const customEvent = new Event('lazyloadImage');
      //document.dispatchEvent(customEvent);
    }, 1000);
  }

  trackClick(url) {
    gtag('event', 'search_result_click', {
      'event_category': 'Search',
      'event_label': url,
      'value': 1
    });
  }

  bindClickTracking() {
    // Select all search result links
    const resultLinks = document.querySelectorAll('.search-result-link');
    
    // Loop through each link and add a click event listener
    resultLinks.forEach(link => {
        link.addEventListener('click', function() {
            // Optionally, you can add custom tracking code here
             gtag('event', 'search_result_click', {
              'event_category': 'Search',
              'event_label': this.href,
              'value': 1
            });
            // Allow default behavior (navigating to the link)
            // You can also log or send the click event for tracking, if needed
            // console.log('Search result clicked:', this.href);
        });
    });
}

  lazyLoadFunc() {
	const images = document.querySelectorAll('[open="true"] .searchImage .lateLoading');
    if(images.length){
      images.forEach(img => {
          if (img?.dataset?.src && !img.classList.contains('lazyloaded')) {
              img.removeAttribute('loading')
              img.classList.add('lazyloaded')
              img.src = img.dataset.src;
          }
  
          if (!img?.dataset?.src && !img.classList.contains('lazyloaded')) {
              img.removeAttribute('loading')
              img.classList.add('lazyloaded')
          }
      });
    }
    
}

  afterRender(resultsMarkup) {
    this.setAttribute('results', true);

    this.setLiveRegionResults();
    this.open();

    setTimeout(() => {
      //const customEvent = new Event('lazyloadImage');
      //document.dispatchEvent(customEvent);
    }, 100);

    this.lazyLoadFunc()
    this.bindClickTracking();
  }

  setLiveRegionResults() {
    this.removeAttribute('loading');
    if(this.querySelector('[data-predictive-search-live-region-count-value]'))
    this.setLiveRegionText(this.querySelector('[data-predictive-search-live-region-count-value]').textContent);
  }

  getResultsMaxHeight() {
    this.resultsMaxHeight = window.innerHeight - document.querySelector('.section-header').getBoundingClientRect().bottom;
    return this.resultsMaxHeight;
  }

  open() {
    // console.log('open')
    //this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`;
    this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || `100%`;
    this.setAttribute('open', true);
    this.input.setAttribute('aria-expanded', true);
    this.isOpen = true;

    if (document.querySelector('.filter-collections')) {
      document.querySelector('.filter-collections').classList.remove('sticky')
      document.querySelector('.filter-collections').classList.remove('extra-top-sticky')
    }
    
    
  }

  close(clearSearchTerm = false) {
    this.closeResults(clearSearchTerm);
    this.isOpen = false;
  }

  closeResults(clearSearchTerm = false) {
    if (clearSearchTerm) {
      this.input.value = '';
      this.removeAttribute('results');
    }
    const selected = this.querySelector('[aria-selected="true"]');

    if (selected) selected.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', '');
    this.removeAttribute('loading');
    this.removeAttribute('open');
    this.input.setAttribute('aria-expanded', false);
    this.resultsMaxHeight = false
    this.predictiveSearchResults.removeAttribute('style');
  }
}

customElements.define('predictive-search', PredictiveSearch);
